const TopNavDivider = () => (
  <div className="w-px bg-slate-700" style={{ height: "var(--mixitone-header-height)" }} />
);

export default TopNavDivider;
